import $ from 'jquery';

const SmoothSroll = ( scrollTop, duration ) => {
	const smooth = 'smooth' === getComputedStyle( document.documentElement ).scrollBehavior;

	if ( smooth ) {
		return window.scrollTo( 0, scrollTop );
	}

	return $( 'html, body' ).stop()
		.animate(
			{
				scrollTop,
			},
			duration || 400,
		);
};

export default SmoothSroll;
